var map = {
	"./add-student-icon.svg": "54fc",
	"./admin-menu.svg": "ba9e",
	"./allow-blue-down.svg": "62ca",
	"./allow-blue-up.svg": "ea7d",
	"./allow-down-grey.svg": "ee87",
	"./allow-down-white.svg": "1235",
	"./allow-down.png": "969f",
	"./allow-down.svg": "69b6",
	"./allow-right.svg": "cd7f",
	"./allow-up.svg": "3f71",
	"./alumni.svg": "f21f",
	"./arrow-right-long.svg": "71da",
	"./assignment-active.svg": "dcf2",
	"./assignment.svg": "3c4b",
	"./blue-caret-down.svg": "a05d",
	"./blue-caret-up.svg": "f502",
	"./blue-clock.svg": "da2b",
	"./briefcase.svg": "ab78",
	"./building.svg": "b6e0",
	"./calendar.svg": "07ce",
	"./candidate-active.svg": "1bba",
	"./candidate.svg": "7868",
	"./carender-table-icon.svg": "e248",
	"./chevron-left.svg": "2639",
	"./chevron-right.svg": "e224",
	"./circle-blue-add.svg": "dcf5",
	"./company/intern-active.svg": "8ae6",
	"./company/intern.svg": "4f7c",
	"./company/internship-active.svg": "355e",
	"./company/internship.svg": "6fcf",
	"./company/public-active.svg": "24a2",
	"./company/public.svg": "23605",
	"./company/s-search-active.svg": "9582",
	"./company/s-search.svg": "66cc",
	"./crm-home.svg": "69b8",
	"./cross-icon.svg": "3eb7",
	"./customer-table-icon.svg": "5af1",
	"./customers-active.svg": "4b3f",
	"./customers.svg": "572f",
	"./delete.svg": "bc5e",
	"./dropdown_active.svg": "244c",
	"./dropdown_nonactive.svg": "39d1",
	"./edit-icon.svg": "9995",
	"./edit.svg": "3541",
	"./event-done.svg": "721a",
	"./events-active.svg": "ccc8",
	"./events.svg": "f532",
	"./file-grey.svg": "80d8",
	"./file.svg": "7045",
	"./filter.svg": "b818",
	"./gray-caret-down.svg": "52e3",
	"./gray-caret-up.svg": "4a12",
	"./green-approved.svg": "5be2",
	"./green-caret-up.svg": "f483",
	"./green-map-marker.svg": "9526",
	"./home-active.svg": "3b63",
	"./icon-down.svg": "7105",
	"./icon-download.svg": "578c",
	"./instructor-active.svg": "e8d3",
	"./instructor.svg": "538a",
	"./leads-active.svg": "9d1b",
	"./leads.svg": "6d01",
	"./map-marker.svg": "cdc7",
	"./menu.svg": "905a",
	"./menu/accounts.svg": "810e",
	"./menu/accounts_active.svg": "f71c",
	"./menu/alumni.svg": "6db8",
	"./menu/alumni_active.svg": "d8d9",
	"./menu/candidates.svg": "20f5",
	"./menu/candidates_active.svg": "93b5",
	"./menu/communication-active.svg": "2322",
	"./menu/communication.svg": "ccce",
	"./menu/dashboard.svg": "4695",
	"./menu/dashboard_active.svg": "47a2",
	"./menu/instructor.svg": "5630",
	"./menu/instructor_active.svg": "ef50",
	"./menu/internship.svg": "3b6f",
	"./menu/internship_active.svg": "1a9c",
	"./menu/leads.svg": "8e7b",
	"./menu/leads_active.svg": "d1b5",
	"./menu/pie-chart-active.svg": "bb2f",
	"./menu/pie-chart.svg": "0d6f",
	"./menu/pitches.svg": "6a80",
	"./menu/pitches_active.svg": "9e5e",
	"./menu/remix-icons/line/business/Group.svg": "886e",
	"./menu/reports.svg": "3958",
	"./menu/reports_active.svg": "02d8",
	"./menu/resumes.svg": "d9f7",
	"./menu/resumes_active.svg": "11f7",
	"./menu/school.svg": "7755",
	"./menu/school_active.svg": "e9ef",
	"./menu/search.svg": "6bd8",
	"./menu/search_active.svg": "3235",
	"./menu/settings-active.svg": "75e9",
	"./menu/settings.svg": "b4f3",
	"./menu/tasks.svg": "017a",
	"./menu/tasks_active.svg": "a8aa",
	"./no_heatmap.svg": "be29",
	"./organization-active.svg": "0284",
	"./organization.svg": "c956",
	"./pensil.svg": "4c4d",
	"./pitch-active.svg": "cb49",
	"./pitch.svg": "3326",
	"./planner-active.svg": "2954",
	"./planner.svg": "a886",
	"./profile-active.svg": "82c3",
	"./profile.svg": "112b",
	"./projects-active.svg": "5a41",
	"./projects.svg": "74bd",
	"./qui.svg": "700e",
	"./quote.svg": "8dc7",
	"./reports-active.svg": "ffcc",
	"./reports.svg": "9955",
	"./resumes-active.svg": "dc9d",
	"./resumes.svg": "fa4c",
	"./search-active.svg": "7c04",
	"./search.svg": "371f",
	"./square-edit-gray.svg": "6a0a",
	"./student/employments-active.svg": "ac9c",
	"./student/employments.svg": "7882",
	"./student/project-active.svg": "f964",
	"./student/project.svg": "3ade",
	"./student/public-active.svg": "5902",
	"./student/public.svg": "83dd",
	"./student/qualifications-active.svg": "da80",
	"./student/qualifications.svg": "c864",
	"./student/s-skills-active.svg": "0366",
	"./student/s-skills.svg": "3249",
	"./task-active.svg": "e926",
	"./task.svg": "cfad",
	"./trush.svg": "0825",
	"./update.svg": "7f66",
	"./white-caret-down.svg": "6e61",
	"./white-caret-up.svg": "a45d",
	"./white-circle-plus.svg": "8866"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "98e2";